export var downloadFile = function (file, fileName) {
    var a = document.createElement('a');
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
};
